function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e0"
    },
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d9d7ca"
    },
    points: "37.5,0.151 37.5,12 49.349,12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "m 18.5,23 -6,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 6,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "m 21.5,28 -9,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 9,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M 25.5,28 C 25.24,28 24.979,27.89 24.79,27.71 24.609,27.52 24.5,27.27 24.5,27 c 0,-0.27 0.109,-0.52 0.3,-0.71 0.36,-0.37 1.04,-0.37 1.41,0 0.18,0.19 0.29,0.45 0.29,0.71 0,0.26 -0.11,0.52 -0.29,0.71 C 26.02,27.89 25.76,28 25.5,28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "m 37.5,28 -8,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 8,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M 12.5,43 C 12.24,43 11.979,42.89 11.79,42.71 11.609,42.52 11.5,42.26 11.5,42 c 0,-0.26 0.109,-0.52 0.29,-0.71 0.37,-0.37 1.05,-0.37 1.42,0.01 0.18,0.18 0.29,0.44 0.29,0.7 0,0.26 -0.11,0.52 -0.29,0.71 C 13.02,42.89 12.76,43 12.5,43 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "m 24.5,43 -8,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 8,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "m 43.5,28 -2,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 2,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "m 34.5,33 -22,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 22,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "m 43.5,33 -6,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 6,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "m 16.5,38 -4,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 4,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "m 30.5,38 -10,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 10,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "m 43.5,38 -9,0 c -0.553,0 -1,-0.448 -1,-1 0,-0.552 0.447,-1 1,-1 l 9,0 c 0.553,0 1,0.448 1,1 0,0.552 -0.447,1 -1,1 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.24bd3934d1395fa465edb2f3a86ed770.svg";
export { ForwardRef as ReactComponent };